import styled from "styled-components";

interface IUserStatusCircleProgressStyled {
    animationDurationMs?: number,
    animationType?: string,
    strokeColor?: string,
    progress: number,
    radius: number,
    scale?: number,
    width: number,
}

export const UserStatusCircleProgressStyled = styled.div<IUserStatusCircleProgressStyled>`
    position: relative;

    width: ${({ radius, width }) => radius * 2 + width}px;
    height: ${({ radius, width }) => radius * 2 + width}px;
    z-index: 1000;
    background-color: var(--color-background-secondary);
    border-radius: 50%;
    transform: scale(${({ scale }) => scale || 1});
    transition: ${({ animationDurationMs, animationType }) => `transform ${animationDurationMs || 400}ms ${animationType || 'ease-out'}`};

    .percent {
        transform-origin: ${({ radius, width }) => radius + width / 2}px ${({ radius, width }) => radius + width / 2}px;
        transform: rotate(-95grad);
    }

    .percent svg {
        width: ${({ radius, width }) => radius * 2 + width}px;
        height: ${({ radius, width }) => radius * 2 + width}px;

        circle {
            width: 100%;
            height: 100%;
            fill: none;
            stroke: var(--color-surface);
            stroke-width: ${({ width }) => width};
            stroke-linecap: round;
            transform: translate(${({ width }) => width / 2}px, ${({ width }) => width / 2}px);
            transition: ${({ animationDurationMs, animationType }) => `stroke-dashoffset ${animationDurationMs || 400}ms ${animationType || 'ease-out'}`};

            &:nth-child(1) {
                stroke: var(--color-background-tertiary);
            }

            &:nth-child(2) {
                stroke-dasharray: ${({ radius }) => radius * 2 * 3.14};
                stroke-dashoffset: ${({ progress, radius }) => radius * 2 * 3.14 - (radius * 2 * 3.14 * progress / 100)};
                stroke: ${({ strokeColor }) => strokeColor || 'var(--color-white-95)'};
            }
            
            &.hidden {
                visibility: hidden;
            }
        }
    }

    .icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    &.state-completed {
        opacity: 0.5;
    }
`;

export const UserStatusCircleProgressLockStyled = styled.div`
    display: flex;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    padding: 6px;
    color: var(--color-label-secondary);
    background: var(--color-background-tertiary);
`;

type IUserStatusCircleProgressSkeletonStyled = Pick<IUserStatusCircleProgressStyled, 'radius' | 'width'>

export const UserStatusCircleProgressSkeletonStyled = styled.div<IUserStatusCircleProgressSkeletonStyled>`
    width: ${({ radius, width }) => radius * 2 + width}px;
    height: ${({ radius, width }) => radius * 2 + width}px;
    border-radius: 50%;
`;
